import { render } from "./DestinationCard.vue?vue&type=template&id=9c3da524&scoped=true&lang=pug"
import script from "./DestinationCard.vue?vue&type=script&lang=ts"
export * from "./DestinationCard.vue?vue&type=script&lang=ts"

import "./DestinationCard.vue?vue&type=style&index=0&id=9c3da524&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9c3da524"

export default script